import styled from "@emotion/styled";
import React, { ChangeEventHandler, Dispatch, FocusEventHandler, KeyboardEventHandler, useEffect, useRef } from "react";
import Input from "../../../components/Input";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { birthdateState, nameState, phoneNumberState } from "../../../../atom/simpleCert";
import { optionState } from "../../../../atom/common";

const Container = styled.div`    
    form {
        margin-top: 16px;
    }
    @media screen and (min-height: 800px) {
        margin-bottom: 16px;
    }
`;

interface Props {
    setValidity: Dispatch<boolean>;
}

const UserInfo = React.memo(({ setValidity }: Props) => {
    const form = useRef<HTMLFormElement>(null)

    const [name, setName] = useRecoilState(nameState);
    const [birthdate, setBirthdate] = useRecoilState(birthdateState);
    const [phone_num, setPhoneNum] = useRecoilState(phoneNumberState);
    const { default_name, default_birthdate, default_phone_num } = useRecoilValue(optionState);

    const checkValidity = () => {
        const elements = form.current?.querySelectorAll("input");
        let validity = true;

        if (!elements) return;

        elements.forEach((ele) => {
            validity = validity && ele.validity.valid;
        });
        setValidity(validity);
    };

    const allowOnlyNumbers: KeyboardEventHandler<HTMLInputElement> = (event) => {
        event.currentTarget.value = event.currentTarget.value.replace(/[^0-9]/g, "");
    };

    const allowOnlyNameChar: KeyboardEventHandler<HTMLInputElement> = (event) => {
        if (event.nativeEvent.isComposing) return;
        event.currentTarget.value = event.currentTarget.value.replace(/[^a-zA-Z가-힣0-9ㄱ-ㅎㅏ-ㅣ\s]/g, "");
    }

    const replaceNotAllowedChars: FocusEventHandler<HTMLInputElement> = (event) => {
        event.currentTarget.value = event.currentTarget.value.replace(/[^a-zA-Z가-힣0-9\s]/g, "");
        setName(event.currentTarget.value.trim());
    }

    useEffect(() => {
        if (default_name) setName(default_name);
        if (default_birthdate) setBirthdate(default_birthdate.replace(/-/g, ""));
        if (default_phone_num) setPhoneNum(default_phone_num.replace(/-/g, ""));
        checkValidity();

    }, [default_name, default_birthdate, default_phone_num])

    useEffect(() => {
        checkValidity();
    }, [name, birthdate, phone_num])

    return (
        <Container>
            <form ref={form}
                onSubmit={(e) => e.preventDefault()}>
                <Input error="이름을 입력해주세요." title={"이름"} type={"text"} inputMode={"text"} placeholder="이름"
                    setValue={setName} onInput={allowOnlyNameChar} onBlur={replaceNotAllowedChars} required value={name} readOnly={!!default_name} />
                <Input
                    pattern={"(19[0-9][0-9]|20\\d{2})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])"}
                    error="생년월일을 입력해주세요." title={"생년월일"} type={"text"} inputMode="numeric" placeholder="생년월일 (ex 19450815)"
                    setValue={setBirthdate} onInput={allowOnlyNumbers} required value={birthdate} readOnly={!!default_birthdate} maxLength={8} minLength={8} />
                <Input
                    pattern={".{11}"}
                    error="휴대전화번호를 입력해주세요." title={"휴대폰번호"} type={"text"} inputMode="numeric" placeholder="휴대전화번호 (-없이 입력)"
                    setValue={setPhoneNum} onInput={allowOnlyNumbers} required value={phone_num} readOnly={!!default_phone_num} minLength={11} maxLength={11}
                />
            </form>
        </Container>
    )
})

export default UserInfo;